/* unplugin-vue-components disabled */import script from "./schoolInfo_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./schoolInfo_copy.vue?vue&type=script&setup=true&lang=js"

import "./schoolInfo_copy.vue?vue&type=style&index=0&id=6af4d674&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af4d674"]])

export default __exports__